
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compression-guide",
      function () {
        return require("private-next-pages/compression-guide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compression-guide"])
      });
    }
  